<template>
  <q-expansion-item
      :icon="headIcon"
      :hide-expand-icon="!compactView"
      class="q-ma-xs"
      :label="`${title} (${items.length})`"
      expand-icon-class="text-white"
      header-class="bg-indigo text-white"
      :default-opened="!$q.screen.lt.md || ($q.screen.lt.md && isDialog)">
    <template v-slot:header>
      <q-item-section class="no-padding">
        {{ `${title} (${items.length})` }}
      </q-item-section>
      <q-item-section side>
        <div class="row items-center">
          <q-btn round flat icon="close" text-color="white" padding="none" v-close-popup v-if="isDialog"/>
        </div>
      </q-item-section>
    </template>
    <q-card flat>
      <q-card-section class="no-padding">
        <q-input dense v-if="isSearching" v-model="filter" filled label="جستجو..."/>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-banner dense class="text-center text-subtitle2 text-bold bg-deep-purple text-white" inline-actions>
          <span v-if="!noPrice">
            {{
              lodash.sumBy(items.filter(rec => rec.Buy_Kind === 1), item => item.Buy_Pay ? item.Buy_Pay : 0).toLocaleString()
            }}
          </span>
          <template v-slot:avatar>
            <q-icon name="attach_money"/>
          </template>
          <template v-slot:action>
            <q-btn v-if="items && items.length>0 && !isDialog" round flat icon="list" padding="none"
                   @click="listView=true">
              <q-tooltip>
                نمایش به صورت لیست
              </q-tooltip>
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-table
            :data="items"
            row-key="Buy_Num"
            wrap-cells
            :hide-header="$q.screen.lt.md || compactView"
            :filter="filter"
            flat
            :pagination="pagination">
          <template v-slot:header>
            <td v-if="!compactView"></td>
            <td class="text-center text-subtitle2">مدت</td>
            <td class="text-center text-subtitle2">شرکت</td>
            <td class="text-center text-subtitle2">تامین کننده</td>
            <td class="text-center text-subtitle2">ثبت کننده</td>
            <td class="text-center text-subtitle2">شماره سفارش</td>
            <td class="text-center text-subtitle2">شماره فاکتور</td>
            <td class="text-center text-subtitle2">تاریخ فاکتور</td>
            <td class="text-center text-subtitle2">مبلغ فاکتور</td>
            <td class="text-center text-subtitle2">کرایه حمل</td>
            <td class="text-center text-subtitle2">فروش فروشگاهی(فوری)</td>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props" class="my-class" v-if="compactView">
              <td>
                <q-card class="shadow-10">
                  <q-card-section class="no-padding text-right">
                    <q-banner dense class="bg-red-10 text-white" inline-actions
                              v-if="props.row.CanConvertToFinalOrder>0">
                      <template v-slot:avatar>
                        <q-icon name="disabled_by_default"/>
                      </template>
                      <span>نتیجه استعلام قیمت به ثبت نرسیده است</span>
                    </q-banner>
                  </q-card-section>
                  <q-card-section class="no-padding text-left">
                    <q-badge v-if="props.row.Buy_Kind===-1" label="برگشتی" color="red-10"
                             text-color="white"/>
                    <q-space v-if="props.row.Buy_Kind===-1"/>
                    <q-badge v-if="props.row.DIFF!==0" rounded :label="`${props.row.DIFF} روز پیش`"
                             :color="props.row.DIFF<=30?'green-14':'red-14'" text-color="white"/>
                    <q-badge v-if="props.row.DIFF===0" rounded :label="`امروز`"
                             color="green-14" text-color="white"/>
                    <q-badge v-if="props.row.ImmediatelySaleCustomer" label="فروش فروشگاهی"
                             color="red-10"
                             class="q-ml-xs" text-color="white"/>
                    <q-chip size="sm" icon="attach_file" color="blue-grey" flat round
                            clickable
                            label="ضمیمه دارد"
                            text-color="white"
                            @click="downloadAttachment(props.row)"
                            v-if="$store.state.roles.some(v=>['admin','can_attach_buyfac_document','user_purchase'].includes(v))
                                                && props.row.HasAttachment">
                      <q-tooltip>
                        دانلود ضمیمه
                      </q-tooltip>
                    </q-chip>
                    <q-space/>
                    <q-chip class="no-margin"
                            :color="props.row.GoodsStorNotConfirmCount>0?'red':'green'"
                            text-color="white" size="sm"
                            v-if="props.row.Recipt_Num"
                            :label="props.row.GoodsStorNotConfirmCount===0?'تایید انباردار':'عدم تایید انبادار'"/>
                    <q-chip :label="props.row.StorName"
                            v-if="props.row.StorName"
                            size="sm" color="blue-grey"
                            text-color="white"/>
                    <q-separator spaced/>
                    <q-chip square class="no-padding" v-if="props.row.ImmediatelySaleCustomerName && props.row.Cs_ID"
                            dense clickable
                            @click="showCustomerInfo(props.row)">
                      <q-chip size="sm" v-if="props.row.ImmediatelySaleCustomerName && props.row.Cs_ID"
                              :label="props.row.Cs_Name" square/>
                      <q-btn flat round
                             replace
                             icon="edit"
                             color="indigo"
                             size="sm"
                             label="انتخاب تامین کننده"
                             @click="customerSelect(props.row)"
                             v-if="!props.row.Cs_ID && $store.state.roles.some(v=>['admin','user_purchase'].includes(v))"
                             padding="none"/>
                      <q-chip size="sm" v-if="props.row.ImmediatelySaleCustomerName"
                              icon="arrow_back" square/>
                      <q-chip size="sm" v-if="props.row.ImmediatelySaleCustomerName"
                              :label="props.row.ImmediatelySaleCustomerName" square/>
                    </q-chip>
                    <q-separator v-if="props.row.ImmediatelySaleCustomerName" spaced/>
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" square clickable icon="apartment"
                            v-if="props.row.Cs_ID"
                            :label="props.row.CompName"/>
                    <q-space/>
                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" square :clickable="!noPrice"
                            v-if="!noPrice && props.row.Cs_Name"
                            icon="person"
                            :label="props.row.Cs_Name"
                            @click="showCustomerInfo(props.row)"/>
                    <q-chip
                        square
                        icon="person"
                        clickable
                        size="sm"
                        text-color="white"
                        color="indigo"
                        label="انتخاب تامین کننده"
                        @click="customerSelect(props.row)"
                        v-if="!props.row.Cs_ID && $store.state.roles.some(v=>['admin','user_purchase'].includes(v))"
                        padding="none"/>
                    <q-chip
                        :size="$q.screen.lt.md?'sm':'11px'" color="brown" text-color="white"
                        square
                        icon="support_agent"
                        :label="props.row.UserName">
                      <q-tooltip>
                        ثبت کننده
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="no-padding" >
                    <q-chip clickable size="11px" color="purple"
                            v-if="props.row.Buy_Kind && props.row.Buy_Kind===1 && (!noPrice || !props.row.Cs_ID)"
                            text-color="white" :label="props.row.Buy_Num"
                            square icon="shopping_basket" @click="showOrderDetails(props.row)">
                      <q-tooltip>
                        شماره سفارش
                      </q-tooltip>
                    </q-chip>
                    <q-chip clickable size="11px" color="purple"
                            v-if="props.row.Factor_Num"
                            text-color="white" :label="props.row.Factor_Num"
                            square icon="shopping_basket" @click="showFactorDetails(props.row)">
                      <q-tooltip>
                        شماره فاکتور
                      </q-tooltip>
                    </q-chip>

                    <q-chip :size="$q.screen.lt.md?'sm':'11px'" color="red" text-color="white"
                            :label="props.row.Buy_Date"
                            square icon="calendar_today">
                      <q-tooltip>
                        تاریخ سفارش
                      </q-tooltip>
                    </q-chip>
                    <q-chip v-if="props.row.Buy_Pay && !noPrice" :size="$q.screen.lt.md?'sm':'11px'"
                            color="deep-orange"
                            text-color="white" square icon="paid"
                            :label="props.row.Buy_Pay | toCurrency">
                      <q-tooltip>
                        مبلغ
                      </q-tooltip>
                    </q-chip>
                    <q-chip v-if="props.row.Buy_Transfer && !noPrice"
                            :size="$q.screen.lt.md?'sm':'11px'"
                            color="deep-orange"
                            text-color="white" square icon="paid"
                            :label="props.row.Buy_Transfer | toCurrency">
                      <q-tooltip>
                        کرایه حمل
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                  <q-card-actions class="no-padding">
                    <q-btn round flat icon="timeline" color="indigo"
                           v-if="props.row.Buy_Kind===1"
                           @click="showOrderTimeLine(props.row)">
                      <q-tooltip>
                        رهگیری سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="!noPrice && !props.row.Buy_State && (parseInt(props.row.Buy_UserID)===parseInt($store.state.userId )|| $store.state.roles.some(v=>['admin'].includes(v)))"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="indigo"
                        icon="edit"
                        @click="editOrder(props.row)">
                      <q-tooltip>
                        ویرایش سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Cs_ID && props.row.Buy_State===0 && $store.state.roles.some(v=>['admin','user_purchase'].includes(v)) && props.row.CanConvertToFinalOrder===0"
                        flat padding="none" size="md" round
                        class="q-mt-xs"
                        color="positive" icon="check"
                        @click="setOrderState(props.row)">
                      <q-tooltip>
                        تایید سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Buy_State===1 && !props.row.Factor_Num && $store.state.roles.some(v=>['admin','can_change_order_state'].includes(v))"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="negative" icon="east"
                        @click="backOrder(props.row)">
                      <q-tooltip>
                        برگشت سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn round color="deep-orange" flat icon="assignment_return"
                           v-if="props.row.Buy_Kind===1 && !props.row.BaseFactorNum && props.row.Factor_Num && props.row.Recipt_Num && !readOnly"
                           @click="showReturnForm(props.row)">
                      <q-tooltip>
                        صدور سند برگشت
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Buy_State===1 && props.row.Factor_Num && $store.state.roles.some(v=>['admin','can_delete_buy_factor'].includes(v)) && !readOnly"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="negative" icon="delete"
                        @click="deleteFactor(props.row)">
                      <q-tooltip>
                        حذف فاکتور
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="!props.row.Factor_Buy_State && !noPrice"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="indigo" icon="archive"
                        @click="archived(props.row)">
                      <q-tooltip>
                        آرشیو سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Factor_Buy_State===1
                                                && props.row.Buy_State===1
                                                && !props.row.Recipt_Num
                                                && $store.state.roles.some(v=>['admin','can_issue_buy_factory_info_store'].includes(v))"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="green" icon="done_all"
                        :disable="!props.row.HasAttachment"
                        @click="issueFactorToStore(props.row)">
                      <q-tooltip>
                        {{
                          props.row.HasAttachment ? 'صدور حواله انبار' : 'فاکتور اصلی را ضمیمه نمایید'
                        }}
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        :id="`factor${props.row.Buy_Num}`"
                        v-if="props.row.Factor_Buy_State===1
                                                && props.row.GoodsStorNotConfirmCount===0
                                                && props.row.Buy_State===1
                                                && props.row.Recipt_Num
                                                && $store.state.roles.some(v=>['admin','can_issue_buy_finance_document'].includes(v))
                                                && !noPrice && !props.row.IsIssueFinanceDocument"
                        flat padding="none" size="md" round class="q-mt-xs"
                        color="positive" icon="done_all"
                        @click="issueFinanceDocument(props.row)">
                      <q-tooltip>
                        صدور سند مالی
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="check" color="green" flat round
                           v-if="props.row.ImmediatelySaleCustomerName
                                               && props.row.Recipt_Num
                                               && noPrice
                                               && $store.state.roles.some(v=>['admin','can_issue_order_from_buy_factor'].includes(v))"
                           @click="issueSaleOrder(props.row)">
                      <q-tooltip>
                        صدور سفارش فروش
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="attach_file" color="blue-grey" flat round
                           @click="loadUploadDialog(props.row)"
                           v-if="props.row.Factor_Num &&
                                               !noPrice &&
                                               $store.state.roles.some(v=>['admin','can_attach_buyfac_document','user_purchase'].includes(v))
                                               && !props.row.HasAttachment">
                      <q-tooltip>
                        ضمیمه نمودن سند خرید از تامین کننده
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="layers_clear" color="red-10" flat round
                           v-if="!noPrice && $store.state.roles.some(v=>['admin','can_attach_buyfac_document','user_purchase'].includes(v))
                                               && props.row.HasAttachment"
                           @click="removeAttachment(props.row)">
                      <q-tooltip>
                        حذف ضمیمه
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="print" color="indigo" flat round
                           v-if="!noPrice && props.row.Recipt_Num"
                           @click="loadReport(props.row)">
                      <q-tooltip>
                        چاپ حواله ورود
                      </q-tooltip>
                    </q-btn>
                    <q-btn flat padding="none" size="md" round class="q-mt-xs"
                           color="indigo"
                           icon="print"
                           @click="printOrder(props.row.Buy_Num, props.row.Buy_Kind, props.row)">
                      <q-tooltip>
                        {{
                          props.row.Cs_ID ? (props.row.Factor_Num ? 'چاپ فاکتور' : (props.row.Buy_State === 0 ? 'چاپ استعلام' : 'چاپ سفارش')) : 'چاپ درخواست خرید'
                        }}
                      </q-tooltip>
                    </q-btn>
                  </q-card-actions>
                  <q-card-section v-if="props.row.Buy_Desc && props.row.Buy_Desc!=='' && !noPrice"
                                  class="no-padding q-ml-xs text-left">
                    <span class="text-subtitle2" style="white-space: pre-wrap;">{{ props.row.Buy_Desc }}</span>
                  </q-card-section>
                  <q-card-section v-if="props.row.ReasonDescription" class="no-padding">
                    <q-banner inline-actions dense class="text-left bg-blue-grey-6 text-white">
                      <template v-slot:avatar>
                        <q-icon name="today" />
                      </template>
                      <span style="white-space: pre-wrap;" dir="ltr">{{ props.row.EntryDateTime | toJalaliDateTime }}</span>
                      <q-space/>
                      <div style="white-space: pre-wrap;" >
                        {{ props.row.ReasonDescription.substring(0,50) }}...
                        <q-tooltip>
                          {{props.row.ReasonDescription}}
                        </q-tooltip>
                      </div>
                    </q-banner>
                  </q-card-section>
                </q-card>
              </td>
            </q-tr>
            <q-tr class="my-class" :props="props" v-if="!compactView">
              <td v-if="!compactView" :style="!noPrice?'width: 160px;min-width: 290px':''">
                <q-card flat>
                  <q-btn icon="attach_file" color="blue-grey" flat round
                         clickable
                         @click="downloadAttachment(props.row)"
                         v-if="$store.state.roles.some(v=>['admin','can_attach_buyfac_document','user_purchase'].includes(v))
                                                && props.row.HasAttachment">
                    <q-tooltip>
                      دانلود ضمیمه
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat icon="timeline" color="indigo"
                         v-if="props.row.Buy_Kind===1"
                         @click="showOrderTimeLine(props.row)">
                    <q-tooltip>
                      رهگیری سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn round color="deep-orange" flat icon="assignment_return"
                         v-if="props.row.Buy_Kind===1 && !props.row.BaseFactorNum && props.row.Cs_ID"
                         @click="showReturnForm(props.row)">
                    <q-tooltip>
                      صدور سند برگشت
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="!noPrice && props.row.Buy_State===0 && (props.row.Buy_UserID===$store.state.userId || $store.state.roles.some(v=>['admin'].includes(v)))"
                      flat padding="none" size="md" round class="q-mt-xs"
                      color="indigo"
                      icon="edit"
                      @click="editOrder(props.row)">
                    <q-tooltip>
                      ویرایش سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Cs_ID && props.row.Buy_State===0 && $store.state.roles.some(v=>['admin','user_purchase'].includes(v)) && props.row.CanConvertToFinalOrder===0"
                      flat padding="none" size="md" round
                      class="q-mt-xs"
                      color="positive" icon="check"
                      @click="setOrderState(props.row)">
                    <q-tooltip>
                      تایید سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Buy_State===1 && !props.row.Factor_Num && $store.state.roles.some(v=>['admin','can_change_order_state'].includes(v))"
                      flat padding="none" size="md" round class="q-mt-xs"
                      color="negative" icon="east"
                      @click="backOrder(props.row)">
                    <q-tooltip>
                      برگشت سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Buy_State===1 && props.row.Factor_Num && $store.state.roles.some(v=>['admin','can_delete_buy_factor'].includes(v))"
                      flat round class="q-mt-xs"
                      color="negative" icon="delete"
                      @click="deleteFactor(props.row)">
                    <q-tooltip>
                      حذف فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="!props.row.Factor_Buy_State"
                      flat padding="none" size="md" round class="q-mt-xs"
                      color="indigo" icon="archive"
                      @click="archived(props.row)">
                    <q-tooltip>
                      آرشیو سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Factor_Buy_State===1 && props.row.Buy_State===1 && !props.row.Recipt_Num && $store.state.roles.some(v=>['admin','can_issue_buy_factory_info_store'].includes(v))"
                      flat padding="none" size="md" round class="q-mt-xs"
                      color="green" icon="done_all"
                      @click="issueFactorToStore(props.row)">
                    <q-tooltip>
                      صدور حواله انبار
                    </q-tooltip>
                  </q-btn>
                  <q-btn icon="print" color="indigo" flat round
                         v-if="!noPrice && props.row.Factor_Num"
                         @click="loadReport(props.row)">
                    <q-tooltip>
                      چاپ حواله ورود
                    </q-tooltip>
                  </q-btn>
                  <q-btn flat padding="none" size="md" round class="q-mt-xs"
                         color="indigo"
                         icon="print"
                         v-if="!noPrice && (props.row.Buy_State===0 || props.row.Factor_Num)"
                         @click="printOrder(props.row.Buy_Num, props.row.Buy_Kind, props.row)">
                    <q-tooltip>
                      {{
                        props.row.Cs_ID ? (props.row.Factor_Num ? 'چاپ فاکتور' : 'چاپ استعلام') : 'چاپ درخواست خرید'
                      }}
                    </q-tooltip>
                  </q-btn>
                  <q-btn icon="check" color="green" flat round
                         v-if="props.row.ImmediatelySaleCustomerName
                                               && props.row.Recipt_Num
                                               && $store.state.roles.some(v=>['admin','can_issue_order_from_buy_factor'].includes(v))"
                         @click="issueSaleOrder(props.row)">
                    <q-tooltip>
                      صدور سفارش فروش
                    </q-tooltip>
                  </q-btn>
                </q-card>
              </td>
              <td class="text-center text-subtitle2">
                <q-badge v-if="props.row.Buy_Kind===-1" label="برگشتی" color="red-10"
                         text-color="white"/>
                <q-space v-if="props.row.Buy_Kind===-1"/>
                <q-chip v-if="props.row.DIFF!==0" rounded :label="`${props.row.DIFF} روز پیش`"
                        :color="props.row.DIFF<=30?'green-14':'red-14'" text-color="white"/>
                <q-chip v-if="props.row.DIFF===0" rounded :label="`امروز`"
                        color="green-14" text-color="white"/>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip square clickable icon="apartment"
                        v-if="props.row.Cs_ID"
                        :label="props.row.CompName"/>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip square :clickable="!noPrice" v-if="!noPrice && props.row.Cs_ID" icon="person"
                        :label="props.row.Cs_Name"
                        @click="showCustomerInfo(props.row)"/>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip
                    color="brown" text-color="white" square
                    icon="support_agent"
                    :label="props.row.UserName">
                  <q-tooltip>
                    ثبت کننده
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip clickable color="purple"
                        v-if="props.row.Buy_Kind && props.row.Buy_Kind===1 && !noOrderInfo"
                        text-color="white" :label="props.row.Buy_Num"
                        square icon="shopping_basket" @click="showOrderDetails(props.row)">
                  <q-tooltip>
                    شماره سفارش
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip clickable color="purple"
                        v-if="props.row.Factor_Num"
                        text-color="white" :label="props.row.Factor_Num"
                        square icon="shopping_basket" @click="showFactorDetails(props.row)">
                  <q-tooltip>
                    شماره فاکتور
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip color="red" text-color="white"
                        :label="props.row.Buy_Date"
                        square icon="calendar_today">
                  <q-tooltip>
                    تاریخ سفارش
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip v-if="props.row.Buy_Pay && !noPrice" color="deep-orange"
                        text-color="white" square icon="paid"
                        :label="props.row.Buy_Pay | toCurrency">
                  <q-tooltip>
                    مبلغ
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center text-subtitle2">
                <q-chip v-if="props.row.Buy_Transfer && !noPrice" color="deep-orange"
                        text-color="white" square icon="paid"
                        :label="props.row.Buy_Transfer | toCurrency">
                  <q-tooltip>
                    کرایه حمل
                  </q-tooltip>
                </q-chip>
              </td>
              <td style="width: 200px">
                <q-chip square class="no-padding" v-if="props.row.ImmediatelySaleCustomerName" dense
                        clickable
                        @click="showCustomerInfo(props.row)">
                  <q-chip size="sm" v-if="props.row.ImmediatelySaleCustomerName"
                          :label="props.row.Cs_Name" square/>
                  <q-chip size="sm" v-if="props.row.ImmediatelySaleCustomerName" icon="arrow_back"
                          square/>
                  <q-chip size="sm" v-if="props.row.ImmediatelySaleCustomerName"
                          :label="props.row.ImmediatelySaleCustomerName" square/>
                </q-chip>

              </td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-dialog v-model="customerInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfo :buy-list="true" :selected-customer="selectedCustomer" :dialog="true"/>
    </q-dialog>
    <q-dialog v-model="orderDetailsDialog" maximized persistent>
      <BuyOrderDetailsDesktop
          v-if="!$q.screen.lt.md"
          :order-info="selectedOrder"
          :issue-factor="canIssueFactor"
          :is-buy-request="isBuyRequest"
          @cancel-dialog="cancelDialog"
          @generated-factory="generateFactor"/>
      <BuyOrderDetailsMobile @cancel-dialog="cancelDialog" @generated-factory="generateFactor"
                             v-if="$q.screen.lt.md"
                             :order-info="selectedOrder"
                             :is-buy-request="isBuyRequest"
                             :issue-factor="canIssueFactor"/>
    </q-dialog>
    <q-dialog v-model="factorDetailsDialog" maximized persistent>
      <BuyFacDetails
          :order-info="selectedOrder"
          :issue-factor="canIssueFactor"
          :no-price="noPrice"
          @cancel-dialog="cancelFacDialog"
          @generated-factory="generateFactor"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-num="selectedSaleNum"
                     :sale-date="selectedSaleDate"
                     :remain-ordered="false"
                     :buy="true"
                     @refresh-data="$emit('refresh-data');"/>
    </q-dialog>
    <q-dialog maximized v-model="buyReturnDialog">
      <ReturnBuyFactor v-if="selectedItem" :factor-info="selectedItem" :sale-kind="selectedItem.Buy_Kind"
                       :sale-num="selectedItem.Factor_Num" @close-dialog="buyReturnDialog=false"/>
    </q-dialog>
    <q-dialog v-model="uploadDocumentDialog">
      <BuyFacLisAttachment v-if="selectedOrder && selectedOrder.Factor_Num"
                           :filename="selectedOrder.Factor_Num.toString()"
                           @uploaded_finish="uploadedFinish"
                           :file-kind="selectedOrder.Buy_Kind"/>
    </q-dialog>
    <q-dialog v-model="listView" maximized>
      <BuyList
          :items="items"
          title="لیست فاکتورهای خرید"
          :read-only="readOnly"
          :no-price="noPrice"
          :no-order-info="noOrderInfo"
          :compact-view="$q.screen.lt.md"
          :is-dialog="true"
          :is-searching="true"
          :filter="searchKey"/>
    </q-dialog>
    <q-dialog v-model="selectCustomerDialog" full-width>
      <SelectCustomer :buy-list="true" :selected-customer="selectedCustomer"
                      :is-dialog="true"
                      :title="`انتخاب مشتری `"
                      @customerSelected="event=>immediatelyCustomerSelected(event)"/>
    </q-dialog>

    <q-dialog v-model="estalamDialog">
      <EstelamPrintDialog
          :goods-name-type="selectedGoodsNameType"
          :factor-info="selectedOrder"/>
    </q-dialog>
  </q-expansion-item>
</template>

<script>
import {mapActions} from "vuex";
import BuyOrderDetailsDesktop from "@/components/Buys/BuyOrderDetailsDesktop";
import BuyOrderDetailsMobile from "@/components/Buys/BuyOrderDetailsMobile";
import BuyFacDetails from "@/components/Buys/BuyFacDetails";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import ReturnBuyFactor from "@/components/Buys/ReturnBuyFactor.vue";
import BuyFacLisAttachment from "@/components/Buys/BuyFacListAttachment.vue";
import SelectCustomer from "@/components/customers/SelectCustomer.vue";
import EstelamPrintDialog from "@/components/PrintDialogs/EstelamPrintDialog.vue";

export default {
  name: "BuyList",
  components: {
    EstelamPrintDialog,
    SelectCustomer,
    BuyFacLisAttachment,
    ReturnBuyFactor,
    OrderTimeLine,
    BuyFacDetails,
    BuyOrderDetailsMobile,
    BuyOrderDetailsDesktop,
    CustomerInfo: () => import("@/components/customers/CustomerInfo")
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: true
    },
    headIcon: {
      type: String,
      default: 'local_mall'
    },
    filter: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    noOrderInfo: {
      type: Boolean,
      default: false
    },
    noPrice: {
      type: Boolean,
      default: false
    },
    compactView: {
      type: Boolean,
      default: false
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedGoodsNameType:undefined,
      estalamDialog: false,
      isBuyRequest: false,
      searchKey: undefined,
      listView: false,
      buyReturnDialog: false,
      selectedSaleNum: undefined,
      selectedSaleDate: undefined,
      selectedSaleKind: undefined,
      selectedItem: undefined,
      canIssueFactor: false,
      orderDetailsDialog: false,
      factorDetailsDialog: false,
      customerInfoDialog: false,
      selectedCustomer: undefined,
      selectedOrder: undefined,
      showTimeLineDialog: false,
      selectCustomerDialog: false,
      pagination: {
        rowsPerPage: 10
      },
      uploadDocumentDialog: false
    }
  },
  methods: {
    ...mapActions({
      changeBuyOrderState: 'Buys/changeBuyOrderState',
      deleteFac: 'Buys/deleteFactor',
      issueStore: 'Buys/issueBuyGoodsIntoStore',
      OrderArchived: 'Buys/orderArchived',
      getCustomerInfo: 'Customers/get_customer_info',
      issueFactorDocument: 'Requests/issueFinanceDocumentBuyFac',
      issueSaleOrderFromBuyFactor: 'Orders/createOrderFromBuyNum',
      downloadFile: 'Buys/downloadFile',
      setAttachmentFlag: 'Buys/setFactorAttachmentFlag',
      updateCustomer: 'Buys/updateCustomer'
    }),
    async printOrder(buyNum, buyKind, rowInfo) {
      this.$q.dialog({
        title: 'نوع گزارش',
        message: 'نوع نمایش عنوان کالا را انتخاب نمایید:',
        options: {
          type: 'radio',
          model: 'opt1',
          // inline: true
          items: [
            { label: 'عنوان درون سازمانی کالا', value: 'LocalName', color: 'secondary' },
            { label: 'عنوان برون سازمانی کالا', value: 'RealName' },
          ]
        },
        cancel: true,
        persistent: true
      }).onOk(async data => {
        this.selectedOrder = rowInfo
        if (rowInfo.Factor_Num) {
          await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات خرید/فاکتور خرید?rs:Format=PDF&Buy_Num=${buyNum}&Buy_Kind=${buyKind}&GoodsNameType=${data}&rc:Parameters=False&rc:Zoom=Page%20Width`)
        } else if (rowInfo.Buy_State === 0) {
          this.selectedGoodsNameType = data
          this.estalamDialog = true
        } else if (rowInfo.Buy_State === 1) {
          await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات خرید/سفارش خرید ?rs:Format=PDF&Buy_Num=${buyNum}&Buy_Kind=${buyKind}&GoodsNameType=${data}&rc:Parameters=False&rc:Zoom=Page%20Width`)
        }
      })
    },
    customerSelect(rowInfo) {
      this.selectedItem = rowInfo
      this.selectCustomerDialog = true
    },
    immediatelyCustomerSelected(args) {
      if (this.selectedItem) {
        this.updateCustomer({
          customerId: args.Cs_ID,
          buyNum: this.selectedItem.Buy_Num,
          buyKind: this.selectedItem.Buy_Kind
        }).then((res) => {
          if (res.data.result === 1) {
            this.selectCustomerDialog = false

            this.selectedItem.Cs_ID = args.Cs_ID
            this.selectedItem.Cs_Name = args.Cs_Name
            this.selectedItem.Buy_UserID = this.$store.state.userId
            this.selectedItem.UserName = `${this.$store.state.firstName} ${this.$store.state.lastName}`

            this.selectedItem = undefined
          }
        })
      }
    },
    downloadAttachment(args) {
      this.downloadFile(
          {
            filePath: `BuyOrders/${args.Factor_Num}_${args.Buy_Kind}.pdf`,
            fileExtension: 'pdf',
            mimeType: 'application/pdf'
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    removeAttachment(args) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'ضمیمه حذف شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        if ('Factor_Num' in args) {
          this.setAttachmentFlag({Buy_Num: args.Factor_Num, Buy_Kind: args.Buy_Kind, flag: 0}).then(() => {
            const searchIndex = this.items.findIndex((item) => item.Buy_Num === args.Buy_Num && item.Buy_Kind === args.Buy_Kind);
            this.items[searchIndex].HasAttachment = false
          })

        } else {
          this.setAttachmentFlag({Buy_Num: args.filename, Buy_Kind: args.fileKind, flag: 0}).then(() => {
            const searchIndex = this.items.findIndex((item) => item.Buy_Num === args.Buy_Num && item.Buy_Kind === args.Buy_Kind);
            this.items[searchIndex].HasAttachment = false
          })
        }
      }).onCancel(() => {
      })

    },
    uploadedFinish(args) {
      const searchIndex = this.items.findIndex((item) => item.Factor_Num === parseInt(args.filename) && item.Buy_Kind === args.fileKind);
      this.items[searchIndex].HasAttachment = true
      this.uploadDocumentDialog = false
    },
    loadUploadDialog(rowInfo) {
      this.selectedOrder = rowInfo
      this.uploadDocumentDialog = true
    },
    async loadReport(args) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/فرم حواله ورود به انبار?rs:Format=PDF&DocumentNo=${args.Factor_Num}&DocumentType=${311}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    issueSaleOrder(rowInfo) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سند سفارش صادر شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.issueSaleOrderFromBuyFactor({Buy_Num: rowInfo.Factor_Num}).then((res) => {
          this.$emit('sale-order-created', res.data[0])
        }).catch(() => {

        })
      }).onCancel(() => {
      })
    },
    issueFinanceDocument(row) {
      const btn = document.getElementById(`factor${row.Buy_Num}`)
      btn.disabled = true

      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سند حسابداری فاکتور خرید صادر شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.$emit('start-issue-finance', row);
        this.issueFactorDocument({
          Sale_Num: row.Factor_Num,
          Sale_Kind: row.Buy_Kind,
          Cs_Code: row.Cs_Code
        }).then((res) => {
          if (res.result === -1) {
            this.$q.notify({
              message: res.msg,
              color: 'negative',
              position: 'top',
              type: 'negative'
            });
            this.$emit('stop-issue-finance', row);
            btn.disabled = false
          } else {
            this.$q.notify({
              message: `فاکتور خرید در سیستم محاسبان به شماره سند ${res.msg} به ثبت رسید`,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
            this.$emit('issue-finance-success', row);
            this.$emit('stop-issue-finance', row);
            btn.disabled = false
          }
        }).catch(() => {
          this.$emit('error-issue-finance', row);
          btn.disabled = false
        })
      }).onCancel(() => {
        this.$emit('stop-issue-finance', row);
        btn.disabled = false
      })
    },
    showReturnForm(rowInfo) {
      this.selectedSaleNum = rowInfo.Buy_Num
      this.selectedSaleKind = rowInfo.Buy_Kind
      this.selectedItem = rowInfo
      this.buyReturnDialog = true
    },
    showOrderTimeLine(row) {
      this.selectedSaleKind = row.Buy_Kind
      this.selectedSaleNum = row.Buy_Num;
      this.selectedSaleDate = row.Buy_Date
      this.selectedItem = row;
      this.showTimeLineDialog = true;
    },
    deleteFactor(orderInfo) {
      this.deleteFac(
          {
            Buy_Num: orderInfo.Factor_Num,
            Buy_Kind: orderInfo.Buy_Kind
          }).then(() => {
        this.$emit('refresh-data')
      })
    },
    archived(rowInfo) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از آرشیو سفارش اطمینان دارید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.OrderArchived({
          Buy_Num: rowInfo.Buy_Num,
          Buy_Kind: rowInfo.Buy_Kind
        }).then(() => {
          this.$emit('order-archived', rowInfo)
        })
      })
    },
    issueFactorToStore(rowInfo) {
      this.issueStore({BuyNum: rowInfo.Factor_Num, BuyKind: rowInfo.Buy_Kind}).then(() => {
        this.$emit('refresh-data')
      })
    },
    cancelDialog() {
      this.canIssueFactor = false
      this.orderDetailsDialog = false;
    },
    cancelFacDialog() {
      this.canIssueFactor = false
      this.factorDetailsDialog = false;
    },
    generateFactor() {
      this.canIssueFactor = false
      this.orderDetailsDialog = false;
      this.$emit('refresh-data')
    },
    showCustomerInfo(customerInfo) {
      this.getCustomerInfo(customerInfo.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    },
    showOrderDetails(orderInfo) {
      if (orderInfo.CanConvertToFinalOrder === 0 && orderInfo.Buy_State === 1 && !orderInfo.Factor_Num) {
        this.canIssueFactor = true
      }
      this.selectedOrder = orderInfo
      this.isBuyRequest = (!orderInfo.Cs_ID)
      this.orderDetailsDialog = true;
    },
    showFactorDetails(orderInfo) {
      if (orderInfo.Factor_Buy_State === 0) {
        this.canIssueFactor = true
      }
      this.selectedOrder = orderInfo
      this.factorDetailsDialog = true;
    },
    editOrder(orderInfo) {
      this.selectedOrder = orderInfo
      if (orderInfo.Cs_ID) {
        this.$router.push(`/buy_order/${orderInfo.Buy_Num}/${orderInfo.Cs_ID}`)
      } else {
        this.$router.push(`/buy_request/${orderInfo.Buy_Num}/${orderInfo.Cs_ID}`)
      }
    },
    setOrderState(orderInfo) {
      this.changeBuyOrderState(orderInfo).then((res) => {
        orderInfo.Buy_State = res[0].Buy_State
      })
    },
    backOrder(orderInfo) {
      this.changeBuyOrderState(orderInfo).then((res) => {
        orderInfo.Buy_State = res[0].Buy_State
      })
    }
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>